import React from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import VisibilitySensor from 'react-visibility-sensor';

import getNumEnding from '../../../../lib/getNumEnding';
import config from '../../../../config';
import styles from './PollItem.scss';

// const propTypes = {
//   title: React.PropTypes.string,
//   endsAt: React.PropTypes.string,
//   id: React.PropTypes.number,
//   status: React.PropTypes.string,
//   basePath: React.PropTypes.string.isRequired,
// };

const defaultProps = {
};

class PollItem extends React.Component {
  state = {
    isVisible: false,
  }
  onChangeVisibility = (isVisible) => {
    this.setState({ isVisible });
  }

  renderTimeLeft = (status, endsAt) => {
    if (status !== 'ended') {
      const ms = moment(endsAt).diff(moment());
      const duration = moment.duration(ms);
      const days = Math.floor(duration.asDays());
      if (days < 1) {
        const hours = duration.hours().toString();
        const minutes = duration.minutes().toString();
        return `До окончания ${hours.length === 1 ? '0' : ''}${hours}:${minutes.length === 1 ? '0' : ''}${minutes}`;
      }
      return `До окончания ${days} ${getNumEnding(days, ['день', 'дня', 'дней'])}`;
    }
    return 'Завершен';
  }

  render() {
    const { title, id, basePath, status, endsAt } = this.props;
    const { isVisible } = this.state;
    const bgClass = `${status}-bg`;
    return (
      <div className={styles.root}>
        <VisibilitySensor onChange={this.onChangeVisibility} intervalDelay={500}>
          <Link to={`${basePath}/${id}`} className={styles.link}>
            <div className={`${styles.title} ${styles[status]}`}>
              <span className={`${styles.circle} ${styles[bgClass]}`} />
              <span>{title}</span>
            </div>
            <div className={styles.days}>
              { isVisible && this.renderTimeLeft(status, endsAt) }&nbsp;
            </div>
          </Link>
        </VisibilitySensor>
        <div className={styles.border} />
        <div className={`${styles.tooltip} ${styles[bgClass]}`}>{config.statuses[status]}</div>
      </div>
    );
  }
}
// PollItem.propTypes = propTypes;
PollItem.defaultProps = defaultProps;

export default PollItem;
